module.exports = __webpack_public_path__ + "static/media/giphy3.7067c29f.gif";